<div class="window">


    <!----------------------------------------------------------------- listado de chats -->
    <div class="listadoChats border-r">
        <div  *ngFor="let item of chatService.chats;  let i=index" (click)="getChat(item.id); cambiarId(item.id,i); chatService.leido(item.id)" class="chat cursorPointer" fxLayoutAlign="space-between center" [ngClass]=" {'backBlue1': chatSeleccionado == i}">

            <div class="mgl05 column w-90">
                <span  class="ft500 ft11" >{{item.nombre}}</span>
                <span class="ft9 gray-6">{{item.id}}</span>
            </div>
            <mat-icon *ngIf="item.status === 'Sin atender'" class="red-5 ft16">brightness_1</mat-icon>
            <mat-icon *ngIf="item.status === 'En proceso'" class="orange-2 ft16">brightness_1</mat-icon>
            <mat-icon *ngIf="item.status === 'Resuelto'" class="green-5 ft16">brightness_1</mat-icon>
        </div>
    </div>
    

    <!------------------------------------------------------------------ chat container -->
    <div *ngIf="chatActual" class="chatcontainer" fxFlex="100%">
        <div fxLayout="column" fxLayoutAlign="space-between" class="fh">
            <!-- top bar chat -->
            <div class="pd05 pdl10 pdr10 border-b" fxLayoutAlign="space-between center">
                <span class="ft500 ft14 gray-9">{{chatActual.nombre}}</span>
                <select [(ngModel)]="chatActual.status" name="orden" (change)="cambiarStatus()" class="cursorPointer">
                    <option value="Sin atender" selected>Sin atender</option>
                    <option value="En proceso" selected>En proceso</option>
                    <option value="Resuelto" selected > Resuelto</option>
                </select>
            </div>

            <!-- messages -->
            <div class="messagesContainer" fxFlex="100%">
                <div *ngFor="let mensaje of chatActual.chat " class="recievedMessage" [ngClass]="{'sentMessage':mensaje.admin == true}">
                    <div class="message">
                        <span class="ft9 gray-6 mgb03"> {{chatActual.nombre.split(' ')[0]}} - </span>
                        <span class="ft11 lineHeight100 mgb03">{{mensaje.mensaje}}</span>
                    </div>
                </div>
            </div>

            <!-- message box input -->
            <div class="pd03 shadow16">
                <textarea [(ngModel)]="mensaje" type="text" class="fw h50px ft11" placeholder="Escribe tu mensaje aqui" (keyup.enter)="enviarMensaje(id)"></textarea>
            </div>
        </div>

    </div>

</div>